// Small, presentation-only building blocks shared across pages.
// None of these hold business logic — they only standardise how
// status text, empty tables and loading rows are displayed.

const SUCCESS_WORDS = ['success', 'approved', 'active', 'completed', 'up'];
const DANGER_WORDS = ['fail', 'reject', 'deactive', 'inactive', 'down', 'expired', 'cancel'];
const WARNING_WORDS = ['pending', 'initiat', 'progress', 'hold'];

export const statusVariant = (rawStatus) => {
  const value = String(rawStatus || '').trim().toLowerCase();
  if (!value) return 'neutral';
  if (['up', 'active'].includes(value)) return 'success';
  if (['down', 'deactive', 'inactive'].includes(value)) return 'danger';
  if (SUCCESS_WORDS.some((word) => value.includes(word))) return 'success';
  if (DANGER_WORDS.some((word) => value.includes(word))) return 'danger';
  if (WARNING_WORDS.some((word) => value.includes(word))) return 'warning';
  return 'neutral';
};

export const StatusBadge = ({ status, variant }) => {
  if (status === undefined || status === null || status === '') return null;
  const resolvedVariant = variant || statusVariant(status);
  return <span className={`status-badge status-badge--${resolvedVariant}`}>{status}</span>;
};

// Small inline spinner used inside buttons while an action is in flight.
export const ButtonSpinner = () => <i className="fa-solid fa-circle-notch fa-spin me-1" aria-hidden="true"></i>;

// Drop-in replacement for the `<tr><td>{tableDataStatus}</td></tr>` rows
// used throughout the app's tables — same colSpan/text contract, nicer look.
export const TableStatusRow = ({ colSpan, status }) => {
  const isLoading = /loading/i.test(status || '');
  return (
    <tr>
      <td colSpan={colSpan}>
        <div className="data-state">
          <i className={`fa-solid ${isLoading ? 'fa-circle-notch fa-spin' : 'fa-inbox'}`}></i>
          <strong>{status || 'Not Found'}</strong>
        </div>
      </td>
    </tr>
  );
};
